import { externalMedrep, getCurrentUserRole } from "modules/utilities/utility";
import api from "../../../api/index";

export function caseSearch(id) {
  const apiEndpoint = externalMedrep.includes(getCurrentUserRole())
    ? `v3/caseSearch?key=${encodeURIComponent(id)}&moreInfo=true`
    : `caseSearchV2?key=${encodeURIComponent(id)}&moreInfo=true`;
  return api.get(apiEndpoint);
}

export function moveOrder(payload) {
  return api.put("move-order", payload);
}

export function allOrders(query) {
  return api.get(`orders?${query}`);
}

export function orderDownload(queryParams) {
  return api.get(`download_all_orders${queryParams}`);
}

export function postAssignOrder(payload) {
  return api.post("assign_order", payload);
}
export function updateOrder(query, payload) {
  return api.put(`update-order-status?category=${query}`, payload);
}

export function openOrders(query) {
  return api.get(`admin_open_orders?${query}`);
}

export function openOrdersDownload(query) {
  return api.get(`download_admin_open_orders?${query}`);
}

export function recentOrderData(page) {
  return api.get(`orders?filterAssigned=true&pageNumber=${page}`);
}

export function recentOrderAssign(payload) {
  return api.post("assign_order", payload);
}

export function assignedDoctors(query) {
  return api.get(`assigned-doctors?${query}`);
}

export function ghostOrders(page){
  return api.get(`orders?status=ghost&pageNumber=${page}`)
}

export function warehousePincode(payload){
  return api.put(`update-pincode-mapping`, payload)
}

export const getEngagementHourly = (startDate, endDate) =>{
  return api.get(`agent-hourly-engagement?startDate=${startDate}&endDate=${endDate}`)
}
export const getReturnOrderDetails = (query) => {
  const { search, startDate = '', endDate = '', page = 1, limit = 10 } = query;
  return api.get(
    `api/returnRequests?search=${encodeURIComponent(search)}&startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}`
  );
};
